import { getApprovedAttorneysApi, getAttorneyNotificationsApi } from 'Constants'
import { Context } from 'Context/Context'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import CasesFeed from './CasesFeed';
import NotificationIcon from 'Components/Icons/NotificationIcon';
import ProfNotifications from '../Notifications/ProfNotifications';
import CompleteAssistantProfile from 'Modals/CompleteAssistantProfile';
import ProfNotificationsWithoutHeader from './ProfNotificationsWithoutHeader';

function AssociatesCasesPage() {
  const {makeApiCallFunc,userDetails} = useContext(Context);
  const [associates, setAssociates] = useState(null);
  const [currentAssociate, setCurrentAssociate] = useState(null);
  const [associateCount, setAssociateCount] = useState(null);
  const [associateNotifications, setAssociateNotifications] = useState(null)
  
  const [loadProfile, setLoadProfile] = useState(null);
  const [loadNotification, setLoadNotification] = useState(null);


    useEffect(() => {
      makeApiCallFunc(
        getApprovedAttorneysApi,
        null,
        ({data}) => setAssociates(data),
        (data) => console.log(data)
      );
      makeApiCallFunc(
        getAttorneyNotificationsApi,
        null,
        ({data}) => {
          console.log(data)
          setAssociateNotifications(data)},
        (data) => console.log(data)
      );
    },[loadNotification])
    const seeCases = (id) => {
        setLoadProfile(id)
    }
    const seeNotifications = () => {
      setLoadProfile(null)
        setLoadNotification(currentAssociate)
    }
  return (
    <>
    {
      loadProfile ?
      <CasesFeed attorney={loadProfile} setLoadProfile={setLoadProfile} associateCount={associateCount} setAssociateCount={setAssociateCount}/>
      :
      loadNotification ? 
      <ProfNotificationsWithoutHeader attorney={loadNotification} setLoadNotification={setLoadNotification}/>
      :
      <>
      <div className='w-full  flex col-span-6' >
        
          {
            associates &&
            <>
            {
            associates.length > 0 ? 
            <div className='w-full flex justify-center flex-col items-center lg:px-40 lg:pb-40'>
              <div className='font-bold w-full mb-4 mt-20 text-sm lg:text-md underline'>The list of attorneys you are acting on behalf of : </div>
              
              {
                associates.map((associate, index) => {
                  
                  return (
                    <>
                    {associate?.userId?.firstName ? 
                    <div key={index} className='w-full hover:bg-green-100 cursor-pointer m-2 flex bg-green-200 rounded justify-between px-6 p-2 items-center'>
                    <div className='w-10 h-10'><img src = {associate?.userId?.profilePic}/></div>
                  <div className='hidden lg:block'>{associate?.userId?.firstName}</div>
                  <div className='hidden lg:block'>{associate?.userId?.lastName}</div>
                  <div className='hidden lg:block'>{associate?.userId?.email}</div>
                  <div className="cursor-pointer rounded font-bold bg-green-600 text-white p-1 text-sm italic" onClick={(e) =>{
                    setCurrentAssociate(associate);
                    setAssociateCount(associateNotifications?.[index]);
                    seeCases(associate)
                    }}>See {associate?.userId?.firstName + " " + associate?.userId?.lastName}  cases profile</div>
                  <div className="cursor-pointer underline text-sm italic" onClick={(e) => {setCurrentAssociate(associate); seeNotifications()}}>
                    <Link>
                      <NotificationIcon count={associateNotifications?.[index]}/>
                    </Link>
                  </div>

                      </div>
                      :
                      <></>
                    }
                    </>
                    
                  )
                }
              )

              }
            </div>
            :
            
              userDetails.profilePic ? 
              <div className='w-full flex justify-center  h-[500px] flex items-center'>
                <div className=' flex shadow-lg border rounded flex-col h-max items-center justify-center bg-sky-200 text-sm lg:text-lg p-4 lg:p-10 italic text-sky-600 '>
                You are not acting on behalf of any attorney. <br/><div className='underline'><Link to="/attorney/profile/4"> Start to request now </Link></div>
                </div>
              </div>
              :
              <CompleteAssistantProfile
              uploadNew={true}
              onClose={() => {}}
              />
            
            }
            </>
          }
      </div>
      </>
    }
    </>
   
  )
}

export default AssociatesCasesPage